import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './userInfo';
import Tracker from './Tracker';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseUrl: 'https://agate-living-millennium.glitch.me'
    },
    getters: {
        getBaseUrl(state) {
            return state.baseUrl
        }
    },
    mutations: {},
    actions: {},
    modules: {
        userInfo,
        tracker: Tracker
    }
})
